export const QUIZ_SUBMIT_PDF = `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>FTM Visit Checklist</title>
    <style>
        body {
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
            margin: 20px;
            background-color: #f5f5f5;
            line-height: 1.6;
        }
        
        .container {
            max-width: 800px;
            margin: 0 auto;
            background-color: white;
            padding: 30px;
            border-radius: 8px;
            box-shadow: 0 2px 10px rgba(0,0,0,0.1);
        }
        
        .logo {
            margin-bottom: 10px;
        }

        .logo-wrapper{
          background: #333;
          margin-bottom: 10px;
          border-radius: 5px;
          height: 55px;
          aspect-ratio: 1/1;
          padding: 5px;
      display: flex;
            align-items: center;
            justify-content: center;
          }
          
          .logo-image {
            height: 40px;
            object-fit: contain;
        }
        
        .logo-text {
            font-size: 24px;
            font-weight: bold;
            color: #232f3e;
        }
        
        .logo-subtext {
            font-size: 18px;
            color: #7cb342;
            font-weight: bold;
        }
        
        .ops-assessment {
            font-size: 14px;
            color: #666;
            font-weight: 500;
        }
        
        .title {
            font-size: 27px;
            font-weight: 700;
            color: #333;
            margin: 10px 0 10px 0;
        }
        
        .date-name {
            font-size: 16px;
            color: #666;
            margin-bottom: 10px;
            font-weight: 400;
        }
        
        .status-complete {
            float: right;
            color: #12855e;
            padding: 6px 16px;
            border-radius: 4px;
            font-size: 15px;
            font-weight: 600;
        }
        
        .summary-table {
            width: 100%;
            border-collapse: collapse;
            margin-bottom: 30px;
            background-color: #e8ecf5;
        }
        
        .summary-table td {
            padding: 15px 12px;
            border-right: 1px solid #c4c4c4;
            text-align: center;
            vertical-align: middle;
        }
        
        .summary-table td:last-child {
            border-right: none;
        }
        
        .summary-label {
            font-size: 13px;
            color: #666;
            font-weight: 500;
            text-transform: uppercase;
            letter-spacing: 0.5px;
            border-right: none !important;
        }

        .summary-value {
            font-size: 16px;
            font-weight: 700;
            color: #333;
        }
        
        .details-table {
            width: 100%;
            border-collapse: collapse;
            margin-top: 20px;
        }
        
        .details-table tr {
            border-bottom: 1px solid #e0e0e0;
        }
        
        .details-table td {
            padding: 12px 0;
            vertical-align: top;
        }
        
        .details-table .label {
            font-weight: 600;
            color: #333;
            width: 150px;
            font-size: 15px;
        }
        
        .details-table .value {
            color: #666;
            text-align: right;
            font-weight: 400;
            font-size: 15px;
        }
        
        .site-info {
            font-size: 14px;
            line-height: 1.4;
            font-weight: 400;
        }
        
        .address {
            font-size: 12px;
            color: #888;
            line-height: 1.3;
            font-weight: 400;
        }
        
       .responses-section {
          margin-top: 30px;
          page-break-before: always;
          page-break-inside: avoid;
       }
        .responses-header {
            background-color: #e8ecf5;
            padding: 12px 15px;
         
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
        
        .responses-title {
            margin: 0;
            font-size: 16px;
            font-weight: 600;
            color: #333;
        }
        
        .responses-count {
            font-size: 14px;
            color: #666;
            font-weight: 500;
        }
        
        .question-item {
    border-bottom: 1px solid #dee2e6;
    border-top: none;
    padding-left: 10px;
    page-break-inside: avoid;
    padding-bottom: 10px;
    margin-top: 10px;
        }
        
        .question-item:last-child {
            border-radius: 0 0 4px 4px;
        }
        
        .question-header {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            margin-bottom: 10px;
        }
        
        .question-title {
            margin: 0;
            font-size: 15px;
            font-weight: 600;
            color: #333;
            flex: 1;
            margin-right: 15px;
            padding-top: 7px
        }
        
        .response-status {
          padding: 13px 12px;
          border-radius: 0;
          font-size: 14px;
          font-weight: 600;
          color: white;
          min-width: 20%;
          text-align: center;
        }
        
        .response-status.poor {
            background-color: #dc3545;
        }
        
        .response-status.yes {
            background-color: #12855e;
        }
        
        .response-status.no {
            background-color: #c60021;
        }
        
        .response-status.na {
            background-color: #6c9bd1;
        }
        
        .question-comment {
            font-size: 13px;
            color: #888;
            line-height: 1.4;
            font-style: italic;
            font-weight: 400;
            margin-bottom: 10px;
        }
        
        .attachments-section {
            margin-top: 30px;
            page-break-inside: avoid;
            page-break-before: auto;
        }
        
        .attachments-header {
            background-color: #e9ecef;
            padding: 12px 15px;
       
        }

        .attachments-title {
            margin: 0;
            font-size: 16px;
            font-weight: 600;
            color: #333;
        }

        .attachment-item {
          page-break-inside: avoid;
          width: 20rem;
          aspect-ratio: 16/9;
        }

        .attachment-item.video {
          width: 20rem;
          aspect-ratio: initial;
        }
       
        .attachment-item img{
            background-color: #2d2d2d50;
            width: 100%;
            height: 100%;
            object-fit: contain;
          }

          .video-placeholder{
            background-color: #2d2d2d50;
            width: 100%;
            aspect-ratio: 16/9;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .video-placeholder svg{
            width: 3rem;
            height: 3rem;
          }

          .attachment-item span{
          font-size: 14px;
          }

        .attachment-label {
            font-size: 14px;
            color: #666;
            font-weight: 600;
        }

    
        @media print {
            body {
                background-color: white;
                margin: 0;
            }
            
            .container {
                box-shadow: none;
                border-radius: 0;
                padding: 20px;
            }
            
            .attachments-section {
                page-break-inside: avoid;
            }
            
            .responses-section {
                page-break-inside: avoid;
            }
            
            .question-item {
                page-break-inside: avoid;
            }
          
            .details-table {
                page-break-inside: avoid;
            }

        }
    </style>
</head>
<body>
    <div class="container">
        <!-- Logo Section -->
        <div class="logo">
            <div class="logo-wrapper">

            <img src={{APP_LOGO}} alt="Simulanis Logo" class="logo-image" >
            </div>
            <div class="ops-assessment">{{INSPECTION_NAME}}</div>
        </div>
        
        <!-- Title and Status -->
        <div style="position: relative;">
            <h1 class="title">{{MACHINE_NAME}}</h1>
            <div class="status-complete">Complete</div>
        </div>
        
        <!-- Date and Name -->
        <div class="date-name">{{DATE}}</div>
        
        <!-- Summary Section -->
        <table class="summary-table">
            <tr>
                <td class="summary-label">Health Status</td>
                <td class="summary-value">{{CORRECT_QUS}} / {{TOTAL_QUS}} ({{HEALTH}}%)</td>
                <td class="summary-label">Flagged Items</td>
                <td class="summary-value">{{WRONG_QUS}}</td>
                <td class="summary-label">Attachments</td>
                <td class="summary-value">{{TOTAL_ATTACHMENT}}</td>
            </tr>
        </table>
        
        <!-- Details Table -->
        <table class="details-table">
          <tbody>
            <tr>
                <td class="label">{{MACHINE_NAME_LABEL}}</td>
                <td class="value site-info">{{MACHINE_NAME}}</td>
            </tr>
            {{SITE_ROW_HERE}}
            <tr>
                <td class="label">{{MACHINE_ID_LABEL}}</td>
                <td class="value">{{MACHINE_ID}}</td>
            </tr>
            <tr>
                <td class="label">Date of Inspection</td>
                <td class="value">{{DATE_TIME}}</td>
            </tr>
            <tr>
                <td class="label">Inspected by</td>
                <td class="value">{{USER_NAME}}</td>
            </tr>
              </tbody>
        </table>
        
        <!-- Responses Section -->
        <div class="responses-section">
            <div class="responses-header">
                <h3 class="responses-title">Total Questions</h3>
                <span class="responses-count"> {{RESPONSE_LENGTH}} </span>
            </div>

            {{REQPONSE_QUESTIONS}}
            
         </div>
    </div>
</body>
</html>`;
